// Components
import { Paper, Stack, Group, Skeleton, Box } from "@mantine/core";

// Styles
import styles from "./PatientPageSkeleton.module.css";

/**
 * Skeleton for patient detail pages - matches sidebar + main content layout.
 * @agentic connections
 */
export const PatientPageSkeleton = () => {
  return (
    <Box className={styles.container}>
      {/* Left Sidebar */}
      <Box className={styles.sidebar}>
        <Stack gap="lg">
          {/* Patient avatar and name */}
          <Group>
            <Skeleton height={64} width={64} radius="xl" />
            <Box className={styles.flexContent}>
              <Skeleton height={20} width={120} mb="xs" />
              <Skeleton height={14} width={80} />
            </Box>
          </Group>

          {/* Patient details list */}
          <Stack gap="md">
            {Array.from({ length: 8 }, (_, i) => (
              <Group key={i} align="flex-start" gap="sm">
                <Skeleton height={20} width={20} radius="sm" />
                <Box className={styles.flexContent}>
                  <Skeleton height={14} width="40%" mb={4} />
                  <Skeleton height={16} width="85%" />
                </Box>
              </Group>
            ))}
          </Stack>

          {/* Edit button */}
          <Skeleton height={36} width="100%" radius="sm" mt="auto" />
        </Stack>
      </Box>

      {/* Main Content Area */}
      <Box className={styles.mainContent}>
        {/* Tab Navigation */}
        <Box className={styles.tabNavigation}>
          <Group gap="lg">
            <Skeleton height={16} width={60} />
            <Skeleton height={16} width={80} />
            <Skeleton height={16} width={90} />
            <Skeleton height={16} width={50} />
            <Skeleton height={16} width={100} />
            <Skeleton height={16} width={50} />
          </Group>
        </Box>

        {/* Content - Timeline skeleton by default */}
        <Box className={styles.contentArea}>
          <Box className={styles.timelineContainer}>
            {/* Timeline connector line */}
            <Box className={styles.timelineConnector} />

            <Stack gap="lg">
              {Array.from({ length: 4 }, (_, i) => (
                <Box key={i} className={styles.timelineItem}>
                  {/* Timeline node */}
                  <Box className={styles.timelineNode} />

                  <Stack gap="sm">
                    <Skeleton height={16} width={160} />
                    <Paper p="md" withBorder>
                      <Group justify="space-between" align="flex-start" mb="sm">
                        <Skeleton height={20} width={140} />
                        <Group gap="xs">
                          <Skeleton height={24} width={70} radius="sm" />
                          <Skeleton height={24} width={55} radius="sm" />
                        </Group>
                      </Group>
                      <Skeleton height={14} width="60%" mb="md" />
                      <Skeleton height={14} width="85%" mb="xs" />
                      <Skeleton height={14} width="70%" />
                    </Paper>
                  </Stack>
                </Box>
              ))}
            </Stack>
          </Box>
        </Box>

        {/* Floating Action Button */}
        <Box className={styles.floatingActionButton}>
          <Skeleton height={56} width={56} radius="50%" />
        </Box>
      </Box>
    </Box>
  );
};
